import { apiClient, Auth } from '@/shared/api'

import { TRoomSchedules } from '../model/schema'

export type RoomSchedulesParams = {
  roomId: number
  year: number
  month: number
}

export const getRoomSchedules = async ({
  roomId,
  year,
  month,
}: RoomSchedulesParams) => {
  const response = await apiClient.get<TRoomSchedules>({
    endpoint: `/rooms/${roomId}/schedules`,
    queryParams: { year, month },
    auth: Auth.REQUIRED,
  })

  return response
}
